import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { Formik, Form, FastField } from 'formik';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { Typography, InputLabel, Paper, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import LabelValueComponent from '../LabelValueComponent';
import FieldWrapper from '../form/FieldWrapper';
import {
	getColorHexUsingComputedStyle,
	getTemplateSectionConfig,
	handleColorChangedForSection,
} from '../../utils';

const useStyles = makeStyles((theme) => ({
	boxContent: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.paper,
		'& .height2rem': {
			height: '2rem',
		},
	},
	descriptionWrapper: {
		paddingBottom: theme.spacing(2),
	},
	eachComponent: {
		width: 300,
		marginBottom: theme.spacing(2.5),
		'& label': {
			marginBottom: theme.spacing(1),
			display: 'block',
		},
	},
	formWrapper: {
		'& .submitButton': {
			textAlign: 'right',
		},
	},
}));

const EditMainDialog = (props) => {
	const { open, handleClose } = props;
	const classes = useStyles();
	// 	const servicesSettings = useStoreState(state => state.template.servicesSettings);
	// const setServicesSettings = useStoreActions(actions => actions.template.setServicesSettings);
	const templateId = useStoreState((state) => state.template.template);
	const templateConfig = getTemplateSectionConfig(templateId, 'main');
	const handleSave = async (values) => {
		console.log('EditServicesDialog handleSave', values);
		handleClose && handleClose();
	};

	const textColorHex = getColorHexUsingComputedStyle('main', 'missionText');

	const renderForm = () => {
		return (
			<Form className={classes.formWrapper}>
				{templateConfig && templateConfig?.tagline && (
					<LabelValueComponent
						label={<InputLabel>{_e('tagline_color')}</InputLabel>}
						value={
							<FastField
								defaultHex={textColorHex}
								name="textColor"
								component={FieldWrapper}
								control="colorpicker"
								callback={handleColorChangedForSection('main', 'missionText')}
							/>
						}
					/>
				)}
				<Box p={1} pt={2}>
					<div className="submitButton">
						<Button
							variant="contained"
							color="primary"
							type="submit"
							// onClick={handleSave}
						>
							{_e('save')}
						</Button>
					</div>
				</Box>
			</Form>
		);
	};

	const renderContent = () => {
		return (
			<div className={`useImageBrowseWrapper`}>
				<Paper elevation={0} className={classes.boxContent}>
					<Typography variant="body2">
						You can change the way your tagline appear on the website by editing the
						settings below.
						<br />
					</Typography>
					<div className="height2rem" />
					<Formik
						initialValues={{
							textColor: textColorHex,
						}}
						validationSchema={Yup.object({
							// subdomain: Yup.string()
							//   .max(15, 'Must be 15 characters or less')
							//   .required('Required')
						})}
						onSubmit={async (values, { setSubmitting }) => {
							// showFormikValues(values, setSubmitting);
							await handleSave(values);
							setSubmitting(false);
						}}
					>
						{renderForm}
					</Formik>
				</Paper>
				<Box p={1} />
			</div>
		);
	};
	return (
		<GenericDialog
			shadedContent
			maxWidth="md"
			title={_e('main')}
			subtitle={_e('customize_tagline')}
			content={renderContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditMainDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
};

export default EditMainDialog;
